import React from 'react'

export default function CartProducts({cartproduct , RemoveProduct , UpdateCount }) {

  
  return (
    <div>
       <div className="cart-product shadow rounded-2 my-3 p-2" >

        <div className="row align-items-center">

          <div className="col-md-2">
               <img className='w-100' src={cartproduct.product.imageCover} alt="" />
             </div>
             <div className="col-md-8">
               {<h4>{cartproduct.product.title}</h4>}
               <h5>{cartproduct.product.category.name}</h5>
               <p className='d-flex justify-content-between'>
                 <span>{cartproduct.price} EGP</span>
                 <span><i className=' fas fa-star rating-color me-1'></i> {cartproduct.product.ratingsAverage}</span>
               </p>
               <p><span className='fw-bolder'>Total Price:</span> {cartproduct.count * cartproduct.price} EGP</p>
             </div>
             <div className="col-md-2">
               <button className='btn text-danger' onClick={()=>{RemoveProduct(cartproduct.product._id)}} >Remove</button>
               <div className="d-flex align-items-center">
                 <button onClick={()=>UpdateCount(cartproduct.product._id ,cartproduct.count- 1 )} className='btn bg-main text-white mx-2'>-</button>
                 <span>{cartproduct.count}</span>
                 <button onClick={()=>UpdateCount(cartproduct.product._id ,cartproduct.count+ 1 )} className='btn bg-main text-white mx-2'>+</button>
               </div>
             </div>
             </div>
             </div>
    </div>
  )
}
